
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaxoptraOrdersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"salesOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"maxoptraOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"salesOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"salesOrderId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxoptraOrderStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxoptraOrderPriority"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastNotifiedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignedDriverReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignedDriverName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignedVehicleReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignedVehicleName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plannedArrivalTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plannedCompletionTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalStopsInRun"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"runNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"runReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"factArrivalTimeGPS"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"factCompletionTimeGPS"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"factArrivalTimeReported"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"factCompletionTimeReported"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"failReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"failComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dispatchInstruction"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"documentNumber"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":752}};
    doc.loc.source = {"body":"query MaxoptraOrdersQuery($salesOrderId: Long!) {\n  data: maxoptraOrders(salesOrderId: $salesOrderId) {\n    id\n    concurrencyVersion\n    uuid\n    reference\n    maxoptraOrderStatus\n    maxoptraOrderPriority\n    lastNotifiedAt\n    createdAt\n    updatedAt\n    createdBy\n    updatedBy\n    assignedDriverReference\n    assignedDriverName\n    assignedVehicleReference\n    assignedVehicleName\n    plannedArrivalTime\n    plannedCompletionTime\n    stopNumber\n    totalStopsInRun\n    runNumber\n    runReference\n    eta\n    factArrivalTimeGPS\n    factCompletionTimeGPS\n    factArrivalTimeReported\n    factCompletionTimeReported\n    failReason\n    failComment\n    dispatchInstruction {\n      id\n      concurrencyVersion\n      uuid\n      documentNumber\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["MaxoptraOrdersQuery"] = oneQuery(doc, "MaxoptraOrdersQuery");
        
